let unique = 1;

export function Column(data) {
    unique += 1;
    this.unique = unique;

    this.code = data.code;
    this.id = data.code;

    this.unit = data.unit;
    let unitString = "";
    if (this.unit === "ruble") unitString = ", ฿";
    else if (this.unit === "HH:MM") unitString = ", чч:мм";

    switch (this.unit) {
        case "ruble":
            unitString = ", ฿";
            break;
        case "HH:MM":
            unitString = ", чч:мм";
            break;
        case "ruble/unit":
            unitString = ", ฿/шт.";
            break;
        default: {
            unitString = "";
        }
    }

    this.name = data.name;
    this.fullName = data.name + unitString;
    this.shortName = data.short_name;
    this.ultraShortName = data.ultra_short_name || data.short_name;
    this.label = this.shortName + unitString;

    this.type = data.data_type;

    this.level = data.level;
    this.isCategory = data.is_category ? 1 : 0;
    this.parentColumnId = data.parent_column;

    this.section = data.section;

    this.characteristic = data.characteristic;
    this.description = data.description;

    this.sort = data.sort;
    this.disabled = !!data.disabled;
}
